/*
 * Cookie consent (banner + preferences modal).
 * Cookie: tfs_consent = "v1-p{0|1}-f{0|1}-a{0|1}-t{unix}"
 *   p = performance (GA4, Hotjar), f = functional (chat), a = advertising (Meta, Pinterest, Criteo, Bing, TradeDoubler)
 * Tags are gated server-side (twigvar.inc reads the cookie), so granting a category reloads the page once
 * to let the tags render. Global Privacy Control (Sec-GPC / navigator.globalPrivacyControl) forces advertising off.
 */
(function () {
    "use strict";

    var COOKIE_NAME = "tfs_consent";

    function gpcActive() {
        return navigator.globalPrivacyControl === true;
    }

    function readConsent() {
        var name = COOKIE_NAME + "=";
        var parts = decodeURIComponent(document.cookie).split(";");
        for (var i = 0; i < parts.length; i++) {
            var c = parts[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                var tokens = c.substring(name.length).split("-");
                if (tokens[0] === "v1") {
                    return {
                        decided: true,
                        p: tokens.indexOf("p1") !== -1,
                        f: tokens.indexOf("f1") !== -1,
                        a: tokens.indexOf("a1") !== -1 && !gpcActive()
                    };
                }
            }
        }
        return { decided: false, p: false, f: false, a: false };
    }

    function writeConsent(p, f, a) {
        if (gpcActive()) {
            a = false; // Global Privacy Control always wins over the user's grant
        }
        var value = "v1-p" + (p ? 1 : 0) + "-f" + (f ? 1 : 0) + "-a" + (a ? 1 : 0) + "-t" + Math.floor(Date.now() / 1000);
        var cookie = COOKIE_NAME + "=" + value + "; Path=/; Max-Age=31536000; SameSite=Lax";
        if (location.protocol === "https:") {
            cookie += "; Secure";
        }
        document.cookie = cookie;
        return { decided: true, p: p, f: f, a: a };
    }

    var banner = document.getElementById("consent-banner");
    var modal = document.getElementById("consent-preferences-modal");
    if (!banner || !modal) {
        return;
    }

    function hideBanner() {
        banner.classList.add("consent-hidden");
    }

    function refreshGpcNotes() {
        if (!gpcActive()) {
            return;
        }
        var note = banner.querySelector("[data-consent-gpc-note]");
        var lock = modal.querySelector("[data-consent-gpc-lock]");
        var advertisingToggle = modal.querySelector('input[data-consent-cat="a"]');
        if (note) {
            note.classList.remove("consent-hidden");
        }
        if (lock) {
            lock.classList.remove("consent-hidden");
        }
        if (advertisingToggle) {
            advertisingToggle.checked = false;
            advertisingToggle.disabled = true;
        }
    }

    function closeMobileMenu() {
        // The burger menu is an offcanvas (headermobileAside in main.js); close it so the modal isn't stacked under it
        var offcanvas = document.querySelector(".mobile-off-canvas-active");
        if (offcanvas) {
            offcanvas.classList.remove("inside");
        }
        var wrapper = document.querySelector(".main-wrapper-3");
        if (wrapper) {
            wrapper.classList.remove("overlay-active-3");
        }
    }

    function openPreferences() {
        closeMobileMenu();
        var state = readConsent();
        var toggles = modal.querySelectorAll("input[data-consent-cat]");
        for (var i = 0; i < toggles.length; i++) {
            toggles[i].checked = state[toggles[i].getAttribute("data-consent-cat")] === true;
        }
        refreshGpcNotes();
        if (window.jQuery && window.jQuery.magnificPopup) {
            window.jQuery.magnificPopup.open({
                items: { src: "#consent-preferences-modal" },
                type: "inline",
                callbacks: {
                    open: function () {
                        window.jQuery("html, body").css("overflow", "hidden");
                    },
                    close: function () {
                        window.jQuery("html, body").css("overflow", "auto");
                    }
                }
            });
        } else {
            modal.classList.remove("mfp-hide");
        }
    }

    function closePreferences() {
        if (window.jQuery && window.jQuery.magnificPopup) {
            window.jQuery.magnificPopup.close();
        } else {
            modal.classList.add("mfp-hide");
        }
    }

    function reloadIfChanged(previous, next) {
        // Server-side gating: a change only takes effect on the next render. Undecided == all off.
        if (previous.p === next.p && previous.f === next.f && previous.a === next.a) {
            return;
        }
        // Never reload mid-payment or on checkout funnel pages (POST-rendered): applies on next navigation.
        var pageTypeGroup = banner.getAttribute("data-page-type-group") || "";
        if (pageTypeGroup === "checkout" || pageTypeGroup === "checkout_funel") {
            return;
        }
        if (typeof window.tfsExpressPayInFlight === "function" && window.tfsExpressPayInFlight()) {
            return;
        }
        location.reload();
    }

    function sendConsentEvent(next, source) {
        // Backend consent statistics: /el attaches visitor_id/session server-side (appcontext.inc).
        // sendBeacon so the event survives the activation reload.
        var payload = JSON.stringify({
            event: "consent_saved",
            details: {
                performance: next.p ? 1 : 0,
                functional: next.f ? 1 : 0,
                advertising: next.a ? 1 : 0,
                gpc: gpcActive() ? 1 : 0,
                source: source,
                uri: window.location.pathname + window.location.search
            }
        });
        if (navigator.sendBeacon) {
            navigator.sendBeacon("/el", payload);
        } else {
            fetch("/el", {
                method: "POST",
                body: payload,
                headers: { "Content-Type": "application/json" },
                keepalive: true
            });
        }
    }

    function decide(p, f, a, source) {
        var previous = readConsent();
        var next = writeConsent(p, f, a);
        sendConsentEvent(next, source);
        hideBanner();
        closePreferences();
        reloadIfChanged(previous, next);
    }

    banner.querySelector("[data-consent-accept]").addEventListener("click", function () {
        decide(true, true, true, "banner_accept");
    });
    banner.querySelector("[data-consent-necessary]").addEventListener("click", function () {
        decide(false, false, false, "banner_necessary");
    });
    modal.querySelector("[data-consent-save]").addEventListener("click", function () {
        var checked = function (cat) {
            var input = modal.querySelector('input[data-consent-cat="' + cat + '"]');
            return !!(input && input.checked);
        };
        decide(checked("p"), checked("f"), checked("a"), "modal_save");
    });

    // "Manage" in the banner + "Cookie preferences" / "Your Privacy Choices" in the footer
    document.addEventListener("click", function (event) {
        var opener = event.target.closest ? event.target.closest(".js-consent-open") : null;
        if (opener) {
            event.preventDefault();
            openPreferences();
        }
    });

    // Escape hides the banner for this page only; no decision is recorded, nothing loads
    document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !banner.classList.contains("consent-hidden")) {
            hideBanner();
        }
    });

    refreshGpcNotes();

    window.tfsConsent = { get: readConsent, openPreferences: openPreferences };
})();
